import { Flex, StyledTd, StyledTr } from "../../../../../styled";
import { Checkbox, Radio } from "@mantine/core";
import { IUser } from "../../../../shared/UserList/UserList.types";

interface Props {
  setValue: (name: string, value: any) => void;
  watch: (name: string) => any;
  user: IUser;
  multiple?: boolean;
}
const CrewListItem = ({ user, setValue, watch, multiple = true }: Props) => {
  const { ref, full_name, active, userid } = user;
  const selectedUsers: string[] = watch("data.selectedUsers") ?? [];

  const toggleUser = (userid: string) => {
    if (multiple) {
      // Multi-select logic
      if (selectedUsers.includes(userid)) {
        const newUsers = selectedUsers.filter((u: string) => u !== userid);
        setValue("data.selectedUsers", newUsers);
      } else {
        const newUsers = [...selectedUsers, userid];
        setValue("data.selectedUsers", newUsers);
      }
    } else {
      // Single-select logic
      if (selectedUsers.includes(userid)) {
        setValue("data.selectedUsers", []);
      } else {
        setValue("data.selectedUsers", [userid]);
      }
    }
  };

  return (
    <StyledTr>
      <StyledTd style={{ textAlign: "center", maxWidth: "200px" }}>
        {ref}
      </StyledTd>
      <StyledTd style={{ textAlign: "center", maxWidth: "200px" }}>
        {full_name}
      </StyledTd>
      <StyledTd style={{ textAlign: "center", maxWidth: "200px" }}>
        {active === 1 ? "Active" : "Inactive"}
      </StyledTd>
      <StyledTd>
        <Flex
          align="center"
          justify="center"
          style={{ position: "relative", zIndex: 0 }}>
          {multiple ? (
            <Checkbox
              checked={selectedUsers.includes(userid)}
              onChange={() => toggleUser(userid)}
            />
          ) : (
            <Radio
              checked={selectedUsers.includes(userid)}
              onChange={() => toggleUser(userid)}
              value={userid}
            />
          )}
        </Flex>
      </StyledTd>
    </StyledTr>
  );
};
export default CrewListItem;
